// removed by extract-text-webpack-plugin
module.exports = {"table":"-table-table-2CwLga-","table-th":"-table-table-th-22NtVE-","table-pager":"-table-table-pager-2PgOpB-","table-button-disabled":"-table-table-button-disabled-1pb5Bk-"};


//////////////////
// WEBPACK FOOTER
// ./src/widgets/table.css
// module id = 1259
// module chunks = 0